const $recipientCheckbox = document.getElementById("gift-card-recipient");
const $recipientEmail = document.getElementById("gift-card-recipient-email");
const $recipientName = document.getElementById("gift-card-recipient-name");
const $recipientMessage = document.getElementById(
  "gift-card-recipient-message"
);
const $recipientToggleWrap = document.querySelector(
  ".gift-recipient__radio-wrap"
);
const $formButton = document.getElementById("AddToCart");

const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
};

if ($recipientCheckbox !== null) {
  const handleRecipientCheckboxChange = () => {
    if ($recipientCheckbox.checked) {
      $recipientToggleWrap.classList.add("active");
      if (!$recipientEmail.value.length) {
        $formButton.disabled = true;
      }
    } else {
      $recipientToggleWrap.classList.remove("active");
      $formButton.disabled = false;
      $recipientEmail.value = "";
      $recipientName.value = "";
      $recipientMessage.value = "";
    }
  };
  const handleRecipientEmailInput = () => {
    if (validateEmail($recipientEmail.value)) {
      $formButton.disabled = false;
    } else {
      $formButton.disabled = true;
    }
  };
  $recipientCheckbox.addEventListener("change", handleRecipientCheckboxChange);
  $recipientEmail.addEventListener("input", handleRecipientEmailInput);
}
